module.exports = __webpack_public_path__ + "img/list.53534e32.svg";